import { Space, OperatorValues } from "@thenounproject/lingo-core";
import { createQueryAction } from "@actions/actionCreators";
import { fetchAnalytics } from "./analyticsHelpers";

type Args = {
  spaceId: Space["id"];
  dateOperators?: OperatorValues;
  portalId: string;
};

type OverviewData = {
  result: Array<{
    date: string;
    guestViews: number;
    memberViews: number;
    totalViews: number;
    uniqueGuests: number;
    uniqueMembers: number;
    uniquePeople: number;
  }>;
};

const [usePortalViewIntervals, fetchPortalViewIntervals] = createQueryAction<Args, OverviewData>(
  {
    entity: "analytics",
    action: "queryPortalViews",
    denormalize: { entity: null },
  },
  async ({ args }) => {
    const reports = {
      portal_view_intervals: {
        id: "intervals",
        entity: "portal_views",
        portal_uuid: args.portalId,
        date_operators: args.dateOperators,
      },
    };

    return { result: (await fetchAnalytics(args.spaceId, reports)).portalViewIntervals };
  }
);

export default usePortalViewIntervals;
export { fetchPortalViewIntervals };
